const LanguageLabels = {
  en: 'English',
  hi: 'हिन्दी',
  ma: 'मराठी',
  gu: 'ગુજરાતી',
  be: 'বাংলা',
  ar: 'العربية',
  'en-SG': 'English (Singapore)',
};

export default LanguageLabels;
